<template>
  <div>
    <!-- Promos Expiring in a week -->
    <div class="form-actions">
      <vx-tooltip text="Extend promo" position="top" v-if="isLocalRule">
        <vs-button
          color="dark"
          type="flat"
          icon-pack="feather"
          icon="icon-clock"
          @click="extendSelectedPromo()"
          :disabled="this.selectedRowCount == 0">
        </vs-button>
      </vx-tooltip>
    </div>
    <div class="custom-grid">
      <div class="scrollable-area">
        <div id="grid-loader" class="vx-card vs-con-loading__container">
          <ag-grid-vue
            id="autoHeightGrid"
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :components="components"
            :rowData="internalExpiringInAWeekData"
            rowSelection="multiple"
            :enableRangeSelection="true"
            :suppressCopyRowsToClipboard="true"
            :suppressDragLeaveHidesColumns="true"
            :animateRows="false"
            :floatingFilter="true"
            :pagination="false"
            :paginationPageSize="paginationPageSize"
            :suppressPaginationPanel="true"
            :suppressRowClickSelection="true"
            :rowClassRules="rowClassRules"
            :statusBar="statusBar"
            :sideBar="sideBar"
            :rowHeight="30"
            :headerHeight="30"
            :floatingFiltersHeight="35"
            :checkboxSelection="true"
            :domLayout="domLayout"
            @row-selected="onRowSelected"
            @pagination-changed="onPaginationChanged"
            @column-resized="onColumnResized">
          </ag-grid-vue>
        </div>
      </div>
    </div>
    <!--  -->
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import "@/assets/scss/radix/extraComponents/agGridStyleOverride.scss";

import CellRendererStatus from "@/components/ag-grid-tables/actions/CellRendererStatus.vue";
import CellRendererCustomTagComments from "@/components/ag-grid-tables/actions/CellRendererCustomTagComments.vue";
import CellRendererAgreementList from "@/components/ag-grid-tables/actions/CellRendererAgreementList.vue";


import EditInternalPromo from "@/components/ag-grid-tables/promos/EditInternalPromo.vue";

import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";

export default {
  name: "InternalPromosExpiringInAWeek",
  components: {
    AgGridVue,
    CellRendererStatus,
    CellRendererCustomTagComments,
    CellRendererAgreementList,
    EditInternalPromo,
    vueCustomScrollbar,
  },

  data() {
    return {
      currentPageSize: "",
      totalRows: "",
      selectedRowCount: "",
      selectedRejectPromo: "",
      selectedRowsId: [],
      autoGroupColumnDef: null,
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        suppressMovable: false,
        filterParams: {
          suppressAndOrCondition: true,
          newRowsAction: "keep",
        },
      },
      rowClassRules: null,
      statusBar: null,
      sideBar: null,
      columnDefs: null,
      domLayout: null,
      internalExpiringInAWeekData: null,
      selectedPromos: [],
      // Cell Renderer Components
      components: {
        CellRendererStatus,
        CellRendererCustomTagComments,
        CellRendererAgreementList
      },
      settings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false,
      },
    };
  },
  watch: {
    windowWidth(val) {
      // Toggle colummn movable
      this.toggleColumnMovable(val);
      // Toggle colummn pinning
      this.toggleColumnPinned(val);
    },
  },
  computed: {
    windowWidth: function () {
      return this.$store.state.windowWidth;
    },
    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },
    status() {
      return event.node;
    },
    paginationPageSize() {
      if (this.gridApi) {
        return this.gridApi.paginationGetPageSize();
      } else {
        return 15;
      }
    },
    totalPages() {
      if (this.gridApi) {
        return this.gridApi.paginationGetTotalPages();
      } else {
        return 0;
      }
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
    isLocalRule() {
      return this.$acl.check('isSuperAdmin') || this.$acl.check('isChannelAdmin') || this.$acl.check('isBIAdmin') || this.$acl.check('isChannelUser') || this.$acl.check('isBIUser');
    },
  },
  methods: {
    onPageSizeChanged(newPageSize) {
      var value = document.getElementById("page-size").value;
      this.gridApi.paginationSetPageSize(Number(value));
    },
    onPaginationChanged() {
      if (this.gridApi) {
        (this.totalRows = this.gridApi.paginationGetRowCount()),
          (this.currentPageSize = this.gridApi.paginationGetPageSize());
      }
    },
    onRowSelected(event) {
      var getStatus = this.gridApi
        .getSelectedNodes()
        .map((x) => x.data)
        .map((x) => x.status);
      getStatus.includes("rejected")
        ? (this.rejectedPromo = true)
        : (this.rejectedPromo = false);
      if (event.node.selected) {
        // Push to selectedPromos
        this.selectedRowCount = this.gridApi.getSelectedNodes().length;
      } else {
        // Remove from selectedPromos
        // this.removeFromArray(this.selectedPromos, event.node.childrenAfterGroup[0].data, 'id');
        this.selectedRowCount = this.gridApi.getSelectedNodes().length;
        // console.log('row-count', this.selectedRowCount);
      }
    },
    setAutoHeight() {
      this.gridApi.setDomLayout("autoHeight");
      // auto height will get the grid to fill the height of the contents,
      // so the grid div should have no height set, the height is dynamic.
      document.querySelector("#autoHeightGrid").style.height = "";
    },
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.8,
      });
    },
    hideLoadingInDiv() {
      this.$vs.loading.close("#div-with-loading > .con-vs-loading");
    },
    toggleColumnMovable(val) {
      if (val <= 576) {
        this.defaultColDef["suppressMovable"] = true;
      } else {
        this.defaultColDef["suppressMovable"] = false;
      }
    },
    toggleColumnPinned(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("domain", null);
      } else {
        this.gridOptions.columnApi.setColumnPinned("domain", "left");
      }
    },
    onColumnResized() {
      this.gridApi.resetRowHeights();
    },
    sizeColumnsToFit() {
      this.gridApi.sizeColumnsToFit();
    },
    disableQueue() {
      this.rowClassRules = {
        "ag-row-disabled":
          'data && (data.status == "new approved" || data.status == "queued" || data.status == "active")',
        "ag-checkbox-disabled": 'data && (data.status == "error")',
      };
    },
    refreshPage() {
      // this.$root.$emit('refreshPage');
      // Reset filters
      // this.gridApi.setFilterModel(null);
      // Reset selection
      this.gridApi.deselectAll();
      // Reset sort
      this.gridApi.setSortModel(null);
      // Table Data AXIOS Call
      this.populateInternalUpdatesData();
    },
    refreshPageWithFilters() {
      this.flags["selectedAll"] = false;
      // Reset filters
      this.gridApi.setFilterModel(null);
      // Reset selection
      this.gridApi.deselectAll();
      // Reset sort
      this.gridApi.setSortModel(null);
      // Table Data AXIOS Call
      this.populateTableData();
    },
    gridSelectAll() {
      this.gridApi.forEachNode((node) => {
        // console.log(node.data);
        // var nodeData =
        if (
          !(
            node.data.status == "new approved" ||
            node.data.status == "rejected" ||
            node.data.status == "error"
          )
        ) {
          if (this.selectAll) {
            // Unselect the node
            node.setSelected(false);
            // console.log('node', node);
          } else {
            // Select the node
            node.setSelected(true);
            var selectedRowId = node.data.id;
            // console.log("selectAll", selectedRowId);
          }
        }
      });
    },
    populateInternalUpdatesData() {
      let self = this;
      /* FIXME: Demo Functionality */

      var am_id = JSON.parse(localStorage.getItem("userDetails")).id,
        role = JSON.parse(localStorage.getItem("userDetails")).role;

      this.internalDataAPI(am_id, role, 7);
    },
    internalDataAPI(am_id, role, days) {
      var url = days
        ? `/local-promos/expiring/${am_id}/${role}/${days}`
        : `/local-promos/expired`;
      /* Get table data for cnic expiring in a week */
      this.$axiosSecure
        .get(url)
        .then((response) => {
          this.internalExpiringInAWeekData = response.data;

          if (this.gridApi) {
            setTimeout(() => {
              // NOTE: If logged in user is Erica, use name to apply filter, don't apply filter for any other logged in user
              if(this.isAMExclusionActive()) {
                var defaultFilter = {
                  'am.name': {
                    type: 'set',
                    values: [process.env.VUE_APP_AM_EXCLUSION],
                  },
                };
                this.gridApi.setFilterModel(defaultFilter);
              }
            }, 50);
          }
        })
        .catch((error) => {
          // Error notification
          self.$vs.notify({
            color: "danger",
            title: "Something went wrong",
            text: "Please contact the server admin",
          });

          console.log("Internal data API", error);
        });
    },
    extendSelectedPromo() {
      var selectedRowsData = this.gridApi.getSelectedNodes().map((x) => x.data);
      this.$root.$emit("selectedGroupEditInternal", selectedRowsData, true);
    },
  },
  beforeMount() {
    this.disableQueue();

    // Populate Tables Data
    this.populateInternalUpdatesData();

    // Reset movable columns on mobile
    this.toggleColumnMovable(this.windowWidth);

    (this.columnDefs = [
      {
        headerName: "Client Name",
        field: "new_reseller.name",
        filter: "agSetColumnFilter",
        minWidth: 175,
        pinned: "left",
        cellClass: "cellCustomWrap",
        checkboxSelection: this.isLocalRule,
      },      
      {
        headerName: "TLD",
        field: "tld.tld_name",
        filter: "agSetColumnFilter",
        minWidth: 100,
        width: 150,
        pinned: "left",
      },
      {
        headerName: "Status",
        field: "status",
        filter: "agSetColumnFilter",
        cellRendererFramework: "CellRendererStatus",
        minWidth: 150,
      },
      {
        headerName: "Type",
        field: "type",
        filter: "agSetColumnFilter",
        minWidth: 160,
      },
      {
        headerName: "AM",
        field: "am.name",
        filter: "agSetColumnFilter",
        minWidth: 175,
        width: 175,
        suppressFilter: this.isAMExclusionActive() ? true : false
      },
      {
        headerName: "Retail Price",
        field: "retail_price",
        filter: "agSetColumnFilter",
        minWidth: 100,
        cellRenderer: (data) => {
          if(data.data.retail) {
            return (
              "<div>" +
              data.data.retail.sign +
              "  " +
              data.data.retail_price +
              "</div>"
            );
          }
        },
      },
      {
        headerName: "Effective 1Yr Price",
        field: "effective_first",
        // filter: "agSetColumnFilter",
        minWidth: 150,
        cellRenderer: (data) => {
          // console.log("data", data.data);
          // this.number();
          if (data.data.type.includes("premium")) {
            return "<div>" + data.data.effective_first_per + "%</div>";
          } else {
            return (
              "<div>" +
              data.data.currency.sign +
              "  " +
              data.data.effective_first +
              "</div>"
            );
          }
        },
      },
      {
        headerName: "Effective Multi-Yr Price",
        field: "effective_multi",
        // filter: "agSetColumnFilter",
        minWidth: 150,
        cellRenderer: (data) => {
          // this.number();
          if (data.data.type.includes("premium")) {
            return "<div>" + data.data.effective_multi_per + "%</div>";
          } else {
            return (
              "<div>" +
              data.data.currency.sign +
              "  " +
              data.data.effective_multi +
              "</div>"
            );
          }
        },
      },
      // {
      //   headerName: "Effe. 1st",
      //   field: "effective_first_per",
      //   filter: "agSetColumnFilter",
      //   minWidth: 150
      // },
      // {
      //   headerName: "Effe. Multi Year",
      //   field: "effective_multi_per",
      //   filter: "agSetColumnFilter",
      //   minWidth: 150
      // },
      {
        headerName: "Start Date",
        field: "start_date",
        filter: "agDateColumnFilter",
        minWidth: 175,
        filterParams: {
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            let dateAsString = cellValue;
            if (dateAsString == null) return -1;
            let dateParts = dateAsString.split("-");
            let cellDate = new Date(
              Number(dateParts[0]),
              Number(dateParts[1]) - 1,
              Number(dateParts[2])
            );
            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          },
          browserDatePicker: true,
        },
      },
      {
        headerName: "End Date",
        field: "end_date",
        filter: "agDateColumnFilter",
        minWidth: 175,
        filterParams: {
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            let dateAsString = cellValue;
            if (dateAsString == null) return -1;
            let dateParts = dateAsString.split("-");
            let cellDate = new Date(
              Number(dateParts[0]),
              Number(dateParts[1]) - 1,
              Number(dateParts[2])
            );
            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          },
          browserDatePicker: true,
        },
      },
      // {
      //   headerName: "Agreement",
      //   field: "general_agreement",
      //   filter: "agSetColumnFilter",
      //   minWidth: 150,
      //   cellRenderer: (data) => {
      //     // console.log('data', data.data.general_agreement);
      //     var dropboxLink = data.data.general_agreement.map((x) => {
      //       return {
      //         label: x.dropbox_link,
      //       };
      //     });
      //     // console.log(dropboxLink.map(x=> x.label));
      //     // console.log('dropboxLink', dropboxLink);

      //     if (dropboxLink.map((x) => x.label).length != 0) {
      //       return (
      //         '<a href="' +
      //         dropboxLink.map((x) => x.label) +
      //         '" target="_blank">Link</a>'
      //       );
      //     } else {
      //       return "";
      //     }
      //   },
      // },
      {
        headerName: "Promo Tag",
        field: "promotag.tag_name",
        filter: "agSetColumnFilter",
        minWidth: 150,
        cellClass: "cellCustomWrap",
      },
      {
        headerName: "Custom Tag",
        field: "customtag.tag_name",
        filter: "agSetColumnFilter",
        minWidth: 150,
        // cellRendererFramework: "CellRendererCustomTagComments",
      },
      {
        headerName: "Period (Yrs)",
        field: "period",
        filter: "agSetColumnFilter",
        minWidth: 120,
      },
      {
        headerName: "Payment Mode",
        field: "payment_mode",
        filter: "agSetColumnFilter",
        minWidth: 150,
      },
      {
        headerName: "List Based",
        field: "list_based",
        filter: "agSetColumnFilter",
        minWidth: 150,
        // hide:true
      },
      {
        headerName: "List Frequency",
        field: "list_frequency",
        filter: "agSetColumnFilter",
        minWidth: 150,
        // hide:true
      },
      {
        headerName: "Agreements",
        field: "dropbox_detail",
        filter: "agSetColumnFilter",
        cellRendererFramework: "CellRendererAgreementList",
        cellRendererParams: {
          source: "localpromo",
        },
        minWidth: 130,
      },
      {
        headerName: "Comments",
        field: "comments",
        filter: "agTextColumnFilter",
        minWidth: 150,
        width: 100,
        cellClass: "cellCustomWrap",
      },
    ]),
      (this.misColumnDefs = [
        {
          headerName: "Client Name",
          field: "batch_id",
          filter: "agTextColumnFilter",
          hide: true,
          minWidth: 55,
          width: 55,
          rowGroup: true,
          // cellRenderer: (data) => {
          //   // console.log('data', data.node.rowIndex);
          //   if(data.value) {
          //     return data.node.rowIndex + 1 ;
          //   }
          //   else {
          //     return ''
          //   }
          // },
        },
        {
          headerName: "Client Name",
          field: "new_reseller.name",
          filter: "agSetColumnFilter",
          pinned: "left",
          minWidth: 175,
        },
        {
          headerName: "Type",
          field: "type",
          filter: "agTextColumnFilter",
          minWidth: 170,
          pinned: "left",
        },
        {
          headerName: "TLD",
          field: "tld.tld_name",
          filter: "agSetColumnFilter",
          minWidth: 100,
          width: 150,
          pinned: "left",
        },
        {
          headerName: "Status",
          field: "status",
          filter: "agSetColumnFilter",
          cellRendererFramework: "CellRendererStatus",
          minWidth: 100,
        },
        {
          headerName: "AM",
          field: "am.name",
          filter: "agSetColumnFilter",
          minWidth: 175,
          width: 175,
          suppressFilter: this.isAMExclusionActive() ? true : false
        },
        {
          headerName: "Effective 1st Year Price",
          field: "effective_first",
          // filter: "agSetColumnFilter",
          minWidth: 150,
          cellRenderer: (data) => {
            // console.log('data', data.data);
            // this.number();
            if (data.data.type.includes("premium")) {
              return "<div>" + data.data.effective_first_per + "%</div>";
            } else {
              return "<div>$" + data.data.effective_first + "</div>";
            }
          },
        },
        {
          headerName: "Effective Multi Year Price",
          field: "effective_multi",
          // filter: "agSetColumnFilter",
          minWidth: 150,
          cellRenderer: (data) => {
            // this.number();
            if (data.data.type.includes("premium")) {
              return "<div>" + data.data.effective_multi_per + "%</div>";
            } else {
              return "<div>$" + data.data.effective_multi + "</div>";
            }
          },
        },
        {
          headerName: "Start Date",
          field: "start_date",
          filter: "agDateColumnFilter",
          minWidth: 175,
          filterParams: {
            comparator: function (filterLocalDateAtMidnight, cellValue) {
              let dateAsString = cellValue;
              if (dateAsString == null) return -1;
              let dateParts = dateAsString.split("-");
              let cellDate = new Date(
                Number(dateParts[0]),
                Number(dateParts[1]) - 1,
                Number(dateParts[2])
              );
              if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
              }
              if (cellDate < filterLocalDateAtMidnight) {
                return -1;
              }
              if (cellDate > filterLocalDateAtMidnight) {
                return 1;
              }
            },
            browserDatePicker: true,
          },
        },
        {
          headerName: "End Date",
          field: "end_date",
          filter: "agDateColumnFilter",
          minWidth: 175,
          filterParams: {
            comparator: function (filterLocalDateAtMidnight, cellValue) {
              let dateAsString = cellValue;
              if (dateAsString == null) return -1;
              let dateParts = dateAsString.split("-");
              let cellDate = new Date(
                Number(dateParts[0]),
                Number(dateParts[1]) - 1,
                Number(dateParts[2])
              );
              if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
              }
              if (cellDate < filterLocalDateAtMidnight) {
                return -1;
              }
              if (cellDate > filterLocalDateAtMidnight) {
                return 1;
              }
            },
            browserDatePicker: true,
          },
        },
        {
          headerName: "Period",
          field: "period",
          filter: "agSetColumnFilter",
          minWidth: 120,
        },
        {
          headerName: "List Based",
          field: "list_based",
          filter: "agSetColumnFilter",
          minWidth: 120,
          // hide:true
        },
      ]),
      // Set Grid sidebar
      (this.sideBar = {
        toolPanels: [
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
            toolPanelParams: {
              suppressRowGroups: true,
              suppressValues: true,
              suppressPivots: true,
              suppressPivotMode: true,
              suppressSideButtons: true,
              suppressColumnSelectAll: true,
              suppressColumnExpandAll: true,
            },
          },
        ],
      });

    this.autoGroupColumnDef = {
      headerName: "",
      minWidth: 55,
      pinned: "left",
      width: 55,
      //headerCheckboxSelection: true,
      // headerCheckboxSelectionFilteredOnly: true,
      cellRendererParams: {
        suppressCount: true,
        checkbox: this.isLocalRule,
      },
    };
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    //agigrid loader
    this.gridApi.showLoadingOverlay();

    // this.applyCurrentUserFilter();
    //set Auto height
    this.setAutoHeight();

    // Resize to fit columns
    this.sizeColumnsToFit();

    // Reset pinned columns on mobile
    this.toggleColumnPinned(this.windowWidth);

    // Page Download Event
    this.$root.$on("downloadPage", () => {
      // AgGrid CSV Export
      this.gridApi.exportDataAsCsv();
    });

    this.$root.$on("tableRefresh", () => {
      // console.log('refresh');
      this.refreshPage();
    });
  },
  destroyed() {
    // Clear Listing Count
    this.$store.dispatch("clearListingCount");

    // Unbind Button Event Listeners
    this.$root.$off("tableRefresh");
  },
};
</script>

<style lang="scss">
.ag-selection-checkbox {
  display: flex;
  align-items: center;
  height: 36px;
}

.ag-row-disabled,
.ag-checkbox-disabled .ag-group-checkbox {
  pointer-events: none;
}

.ag-row-disabled .ag-group-checkbox,
.ag-checkbox-disabled .ag-group-checkbox {
  opacity: 0.3;
}

.ag-row-level-1 .ag-group-value,
.text-capitalize input {
  text-transform: capitalize;
}

//Hide grouping arrow
.ag-group-expanded,
.ag-group-contracted {
  display: none !important;
}

.ag-group-checkbox {
  margin-left: 0 !important;
}

.text-capitalize {
  text-transform: capitalize;
}

.vs-tabs--content {
  padding: 0;
}

// .line-vs-tabs {
//   // left: 140px;
//   width: 35px;
//   height: 2px;
//   transform: scaleX(1);
//   top: 29px;
// }

</style>